//Import React
import React, { useCallback } from "react";
import Select from 'react-select';
import { components } from "react-select";
// Import icon
import downArrow from '../../../assets/icons/downArrow.svg';

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt='CustomArrow' />
        </components.DropdownIndicator>
    );
};

const AddCodesModal = ({
    showModal,
    setShowModal,
    temporarySelections,
    setTemporarySelections,
    selectedCodes,
    setSelectedCodes,
    subsidyCodes,
    selectedSubsidy }) => {

    // Función para obtener códigos filtrados
    const getFilteredCodes = useCallback(() => {
        if (!selectedSubsidy) return [];

        return Object.entries(subsidyCodes)
            .filter(([code, codeData]) => {
                const isAllowedSubsidy = codeData.allowedSubsidies.includes(selectedSubsidy.value);
                const isNotInSelectedCodes = !selectedCodes.some(selected => selected.code === code);
                const isNotInTemporary = !temporarySelections.some(temp => temp.value === code);

                return isAllowedSubsidy && isNotInSelectedCodes && isNotInTemporary;
            })
            .map(([code, codeData]) => ({
                value: code,
                label: `${code} - ${codeData.name}`,
                name: codeData.name
            }));
    }, [selectedSubsidy, selectedCodes, temporarySelections, subsidyCodes]);

    // Función para manejar cambios en la selección
    const handleCodeChange = (selected) => {
        if (selected === null) {
            setTemporarySelections([]); // Limpiar selecciones si se presiona 'x'
        } else {
            setTemporarySelections(Array.isArray(selected) ? selected : [selected]);
        }
    };

    // Función para guardar códigos seleccionados
    const handleAddCode = () => {
        if (!temporarySelections || temporarySelections.length === 0) return;
        setSelectedCodes(prev => {
            const newCodes = [
                ...prev,
                ...temporarySelections.map(selection => ({
                    code: selection.value,
                    name: subsidyCodes[selection.value].name
                }))
            ];

            // Ordenar por código
            return newCodes.sort((a, b) => a.code.localeCompare(b.code));
        });
        setTemporarySelections([]);
        setShowModal(false);
    };

    // Función para cerrar el modal
    const handleClose = () => {
        setShowModal(false);
        setTemporarySelections([]);
    };

    return (
        showModal && (
            <section className='new-category-modal flex'>
                <span className='modal-content flex'>
                    <h3>Agregar Nueva Categoría</h3>
                    <span className='input-text flex'>
                        <label className='label-input'>Subcategoría</label>
                        <Select
                            isMulti={true}
                            value={temporarySelections || []}
                            onChange={handleCodeChange}
                            options={getFilteredCodes()}
                            placeholder="Buscar por código o nombre"
                            className="custom-select"
                            classNamePrefix="custom-select"
                            components={{ DropdownIndicator }}
                            isClearable={true}
                            isSearchable={true}
                            hideSelectedOptions={false}
                            filterOption={(option, input) => {
                                if (!input) return true;
                                const inputValue = input.toLowerCase();
                                return (
                                    option.value.toLowerCase().includes(inputValue) ||
                                    option.label.toLowerCase().includes(inputValue)
                                );
                            }}
                            noOptionsMessage={() => "No se encontraron códigos disponibles"}
                        />
                    </span>
                    <span className='modal-actions flex'>
                        <button
                            onClick={handleAddCode}
                            className='save-button button'
                            disabled={!temporarySelections || temporarySelections.length === 0}
                        >
                            Guardar ({temporarySelections?.length || 0} {(temporarySelections?.length || 0) === 1 ? 'código' : 'códigos'})
                        </button>
                        <button
                            onClick={handleClose}
                            className='cancel-button button'
                        >
                            Cancelar
                        </button>
                    </span>
                </span>
            </section>
        )
    );
};

export default AddCodesModal;